import type { FC } from 'react'
import * as Yup from 'yup'
import { TFunction } from 'i18next'
import { useTranslation } from 'react-i18next'
import { TextFieldProps } from '@mui/material'

import { TextFieldInput } from './TextFieldInput.js'

type Props = TextFieldProps & {
  name: string
}

export const MobileNumberInput: FC<Props> = ({ name, ...props }: Props) => {
  const { t } = useTranslation()
  return (
    <TextFieldInput
      {...props}
      name={name}
      type="tel"
      label={t('inputs.mobileNumberInput.mobileNumberLabel')}
      data-test="mobile-number-input"
    />
  )
}

export const createMobileNumberValidationSchema = (
  t: TFunction,
  pattern = '',
  minLength = 10,
  maxLength = 10
): Yup.StringSchema<string, Yup.AnyObject, '', 'd'> =>
  Yup.string()
    .default('')
    .required(t('inputs.mobileNumberInput.mobileNumberIsRequiredErrorMessage'))
    .min(minLength, t('inputs.mobileNumberInput.mobileNumberIsInvalidErrorMessage', { min: minLength }))
    .max(maxLength, t('inputs.mobileNumberInput.mobileNumberIsInvalidErrorMessage', { min: minLength }))
    .matches(new RegExp(pattern), t('inputs.mobileNumberInput.mobileNumberInvalidFormatMessage', { min: minLength }))
